<template>
  <div class="app">
	<!-- <heads :title="title" type="2"></heads> -->
	<div class="content">
		<div class="content-nav">
			<div class="content-nav-card">
				<div>
					<img src="../../assets/images/people/1.jpg" alt="">
				</div>
				<div>
					<div>
						<h3>广哥</h3>
						<span>孝子孝媳</span>
					</div>
					<p>安康代表团</p>
					<p>汉阴县县委书记</p>
				</div>
			</div>
		</div>
		<div class="content-nav-box">
			<div>
				<p>性别</p>
				<p>男</p>
			</div>
			<div>
				<p>民族</p>
				<p>汉族</p>
			</div>
			<div>
				<p>籍贯</p>
				<p>陕西武功</p>
			</div>
			<div>
				<p>出生年月</p>
				<p>1973-03</p>
			</div>
			<div>
				<p>文化程度</p>
				<p>中央党校大学</p>
			</div>
			<div>
				<p>代表团</p>
				<p>安康代表团</p>
			</div>
			<div>
				<p>党派</p>
				<p>中共党员</p>
			</div>
			<div>
				<p>现任职务</p>
				<p>汉阴县委书记</p>
			</div>
		</div>
		<div class="content-nav-lyb">
			<div v-html="`<h2>富文本</h2>`"></div>
		</div>
	</div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker } from 'vant'
export default {
	data(){
		return{
			title:"向代表留言",
			checked: false,
			checked2:false,
			nav_title:"",
			text:"这个人生平",
			list:{},
			id:"",
			show:false,
			wx_data:{
				wechatName:"",
				phone:"",
				sysOrgCode:""
			},
			columns:[]
		}
	},
	mounted() {
		let params={
			openId:""
        }
		params.openId = localStorage.getItem('openId')
		getAction("/system/sysuserwechatbind/get/by/openid",params).then((res)=>{
			console.log("openid",res.result);
			if(res.code==200){
				this.wx_data = res.result
			}
		})
	},
	methods:{
		init(){
			let params = {id:""}
			params.id = this.$route.query.id
			this.id = this.$route.query.id
			console.log("id",params.id);
			getAction("/akpc/deputiesmanage/query/by/id/for/list",params).then(res=>{
				console.log("res",res);
				if(res.code==200){
					this.list = res.result[0]
				}
				console.log("list",this.list);
				
			})
		},
		async inits(){
			let that = this
			let params = {
				category : 2,
			}
		    await getAction("/sys/sysDepart/queryTreeList/by/category/xzzz",params).then(res=>{
				this.list = res.result[0]
				console.log("list",this.list);
				let x_list = [
					{
						text:"全部",
						value:0
					}
				]
				let z= [],zj= [],c= [],cj = []
			    // if(this.list){
				// this.list.map((item,index)=>{
				// 	item.text = item.departName
				// 	item.children = item
				// })
				this.list.children.map((item,index)=>{
					item.text = item.departName
					console.log("item",item);
					item.children.map((itm,idx)=>{
						 itm.text = itm.departName
						 itm.children.map((im,ix)=>{
							 im.text = im.departName
						 })
					})
				})
				// }
				 this.columns = this.list.children
				console.log("columns",this.columns);
				
				// this.columns = this.list
				// zj.unshift(x_list[0])
				// cj.unshift(x_list[0])
			})
		}
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	height: 100vh;
	background-color: #f6f7f9;
}
p{
	margin: 0px;
	padding: 0px;
}
input{
	border: none
}
.content{
	padding: 10px;
	font-size: 16px;
	box-sizing: border-box;
	&-nav{
		width: 100%;
		border-radius: 4px;
		background: white;
		&-card{
			padding: 10px 20px;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			>div:first-child{
				width: 24%;
				height: 80px;
				border: 1px solid #f5f5f5;
				img{
					width: 100%;
					height: 100%;
				}
			}
			>div:last-child{
				width: 64%;
				>div{
					display: flex;
				}
				h3{
					font-size: 18px;
					margin: 0px 12px 0px 0px;
				}
				p{
					font-size: 12px;
					margin: 10px 0px;
				}
				span{
					border-radius: 4px;
					text-align: center;
					display: block;
					line-height: 16px;
					padding: 2px 6px;
					border: 1px solid #0099ff;
					background-color: #e6f5ff;
					color: #0099ff;
					font-size: 12px;
				}
			}
		}
		&-box{
			width: 100%;
			margin: 20px 0px;
			border-radius: 12px;
			background: white;
			padding: 10px;
			box-sizing: border-box;
			>div{
				display: flex;
				justify-content: space-between;
				padding: 14px 0px;
				font-size: 14px;
				border-bottom:1px solid #f5f5f5;
			}
			>div:last-child{
				border:none
			}
			input{
				text-align: right
			}
		}
		&-lyb{
			width:100%;
			border-radius: 12px;
			padding: 20px 10px;
			box-sizing: border-box;
			background:white;
			font-size: 14px;
			>p{
				font-size: 15px;
			}
			>div{
				display: flex;
				padding: 10px 0px;
				margin: 10px 0px;
				border-bottom: 1px solid #f5f5f5;
				justify-content: space-between;
				flex-wrap: wrap;
				span{
					color: red;
				}
				input{
					text-align: right;
				}
				textarea{
					width: 100%;
					height: 100px;
					margin: 10px 0px 0px 10px;
					border: none;
					resize: none;
				}
			}
			>div:last-child{
				border: none;
				margin-bottom: 0px;
				padding-bottom: 0px;
				p{
					text-indent: .8em;
				}
			}
		}
	}
	textarea:disabled {
		background: white
	}
}
</style>